module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-bottom-backplates-remnants.1dcfab93.png";